import React from "react";

import styles from "./indicator_number.module.css";

const IndicatiorCircle = ({
  txt,
  backgroundColor,
  width,
  height,
  color,
  border,
  fontSize,
  margin = 0,
  cursor = "default",
  onClick,
}) => {
  return (
    <div
      className={styles.numberCircle}
      style={{
        backgroundColor,
        width,
        height,
        color,
        border,
        fontSize,
        margin,
        cursor,
      }}
      onClick={onClick ? onClick : null}
    >
      {txt}
    </div>
  );
};

export default IndicatiorCircle;
